module.exports = __webpack_public_path__ + "assets/img/slogan-684cc1d0.png";